import { createSlice } from 'utils/@reduxjs/toolkit';
import { IProfileState, LoginState } from './types';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { loginSaga } from './saga';
import { PayloadAction } from '@reduxjs/toolkit';
import { StorageServices } from 'utils/storage';
import uniq from 'lodash/uniq';
import flattenDeep from 'lodash/flattenDeep';
import values from 'lodash/values';
import { USER_PERMISSION } from 'common/config/permission';
import { PERMISSION } from '../../../common/config/constant';

export const initialState: LoginState = {
  token: '',
  refreshToken: '',
  isLoading: false,
  error: false,
  infoProfile: {
    id: 0,
    is_supper: false,
    avatar: '',
    last_name: '',
    first_name: '',
    email: '',
    phone: null,
    roles: [],
    username: '',
    gender: 0,
  },
};

const slice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    handleLogin: (state) => {
      state.isLoading = true;
      state.error = false;
    },
    loginSuccess: (state, { payload }) => {
      state.token = payload.token;
      state.isLoading = false;
      state.error = true;
    },
    loginFailure: (state) => {
      state.isLoading = false;
      state.error = false;
    },
    logout: (state) => {
      state.token = '';
      state.error = true;
      state.infoProfile = initialState.infoProfile;
    },
    fetchInfoProfileSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.infoProfile = payload;
      if (payload.is_supper) {
        StorageServices.setData(
          PERMISSION,
          JSON.stringify(values(USER_PERMISSION))
        );
      } else {
        const permission = uniq(
          flattenDeep(
            payload?.roles?.map((item: any) => item.permissions)
          )?.map((item: any) => item.name)
        );
        StorageServices.setData(PERMISSION, JSON.stringify(permission));
      }
    },
    fetcInfoProfileFailure: (state) => {
      state.isLoading = false;
      state.infoProfile = initialState.infoProfile;
    },
    fetchInfoProfile: (
      state,
      action: PayloadAction<{ method: string; data?: IProfileState }>
    ) => {
      state.isLoading = true;
    },
  },
});

export const { actions, reducer } = slice;

export const useLoginSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: loginSaga });

  return {
    actions: slice.actions,
  };
};
